import React from 'react';

function SimsCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="128"
      height="128"
      viewBox="0 0 128 128"
    >
      <defs>
        <linearGradient id="linearGradient-1" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#253054" />
          <stop offset="100%" stopColor="#0A1435" />
        </linearGradient>
        <circle id="path-2" cx="64" cy="64" r="64" />
        <path
          id="path-4"
          d="M.622 2.323v35.8a2.6 2.6 0 002.6 2.6h26.8a2.6 2.6 0 002.6-2.6V10.122a2.6 2.6 0 00-.599-1.66L25.556.663a2.6 2.6 0 00-2.001-.94H3.222a2.6 2.6 0 00-2.6 2.6z"
        />
        <filter
          id="filter-5"
          width="109.4%"
          height="114.6%"
          x="-4.7%"
          y="-3.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.145098039 0 0 0 0 0.188235294 0 0 0 0 0.329411765 0 0 0 1 0"
          />
        </filter>
        <path
          id="path-6"
          d="M.622 2.323v35.8a2.6 2.6 0 002.6 2.6h26.8a2.6 2.6 0 002.6-2.6V10.122a2.6 2.6 0 00-.599-1.66L25.556.663a2.6 2.6 0 00-2.001-.94H3.222a2.6 2.6 0 00-2.6 2.6z"
        />
        <filter
          id="filter-7"
          width="109.4%"
          height="114.6%"
          x="-4.7%"
          y="-3.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.145098039 0 0 0 0 0.188235294 0 0 0 0 0.329411765 0 0 0 1 0"
          />
        </filter>
        <path
          id="path-8"
          d="M.622 2.323v35.8a2.6 2.6 0 002.6 2.6h26.8a2.6 2.6 0 002.6-2.6V10.122a2.6 2.6 0 00-.599-1.66L25.556.663a2.6 2.6 0 00-2.001-.94H3.222a2.6 2.6 0 00-2.6 2.6z"
        />
        <filter
          id="filter-9"
          width="109.4%"
          height="114.6%"
          x="-4.7%"
          y="-3.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.145098039 0 0 0 0 0.188235294 0 0 0 0 0.329411765 0 0 0 1 0"
          />
        </filter>
        <path
          id="path-10"
          d="M.622 2.323v35.8a2.6 2.6 0 002.6 2.6h26.8a2.6 2.6 0 002.6-2.6V10.122a2.6 2.6 0 00-.599-1.66L25.556.663a2.6 2.6 0 00-2.001-.94H3.222a2.6 2.6 0 00-2.6 2.6z"
        />
        <filter
          id="filter-11"
          width="109.4%"
          height="114.6%"
          x="-4.7%"
          y="-3.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.145098039 0 0 0 0 0.188235294 0 0 0 0 0.329411765 0 0 0 1 0"
          />
        </filter>
        <linearGradient id="linearGradient-12" x1="50.058%" x2="50.058%" y1="100.005%" y2=".008%">
          <stop offset="0%" stopColor="#BC24FF" />
          <stop offset="52.37%" stopColor="#04A7FF" />
          <stop offset="100%" stopColor="#00D5C2" />
        </linearGradient>
        <path
          id="path-13"
          d="M.622 2.323v35.8a2.6 2.6 0 002.6 2.6h26.8a2.6 2.6 0 002.6-2.6V10.122a2.6 2.6 0 00-.599-1.66L25.556.663a2.6 2.6 0 00-2.001-.94H3.222a2.6 2.6 0 00-2.6 2.6z"
        />
        <filter
          id="filter-14"
          width="109.4%"
          height="114.6%"
          x="-4.7%"
          y="-3.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.561273072 0 0 0 0 0.0835478841 0 0 0 0 0.793591486 0 0 0 1 0"
          />
        </filter>
        <circle id="path-15" cx="64" cy="64" r="64" />
        <filter
          id="filter-16"
          width="112.5%"
          height="112.5%"
          x="-6.2%"
          y="-6.2%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology in="SourceAlpha" radius="6" result="shadowSpreadInner1" />
          <feOffset dy="2" in="shadowSpreadInner1" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 0.0392156863 0 0 0 0 0.0784313725 0 0 0 0 0.207843137 0 0 0 0.502566251 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-826 -292)">
          <g transform="translate(826 292)">
            <mask id="mask-3" fill="#fff">
              <use xlinkHref="#path-2" />
            </mask>
            <use fill="url(#linearGradient-1)" xlinkHref="#path-2" />
            <g mask="url(#mask-3)">
              <g transform="rotate(-8 546.136 -72.79)">
                <g>
                  <use fill="#000" filter="url(#filter-5)" xlinkHref="#path-4" />
                  <use fill="#545D79" xlinkHref="#path-4" />
                </g>
                <g fillRule="evenodd" strokeWidth="1" transform="translate(4.17 16.544)">
                  <path
                    fill="#FFF"
                    d="M3.333 0h15.334c1.159 0 1.58.12 2.003.347.424.227.756.56.983.983.226.424.347.844.347 2.003v12.334c0 1.159-.12 1.58-.347 2.003-.227.424-.56.756-.983.983-.424.226-.844.347-2.003.347H3.333c-1.159 0-1.58-.12-2.003-.347a2.362 2.362 0 01-.983-.983C.121 17.246 0 16.826 0 15.667V3.333c0-1.159.12-1.58.347-2.003.227-.424.56-.756.983-.983C1.754.121 2.174 0 3.333 0z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 -2.7586575e-13L8.38095238 -2.40005546e-13 8.38095238 5.27777778 7.33333333 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 13.7222222L8.38095238 13.7222222 8.38095238 19 7.33333333 19z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 0L14.6666667 0 14.6666667 5.27777778 13.6190476 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 13.7222222L14.6666667 13.7222222 14.6666667 19 13.6190476 19z"
                  />
                  <path
                    stroke="#2F52FB"
                    d="M15.31 5.778c.727 0 .998.058 1.266.201.23.123.41.303.532.532.143.268.202.539.202 1.267h0v3.444c0 .728-.059.999-.202 1.267-.122.23-.302.41-.532.532-.268.143-.539.201-1.266.201h0-8.62c-.727 0-.998-.058-1.266-.201a1.279 1.279 0 01-.532-.532c-.143-.268-.202-.539-.202-1.267h0V7.778c0-.728.059-.999.202-1.267.122-.23.302-.41.532-.532.268-.143.539-.201 1.266-.201h0z"
                  />
                </g>
              </g>
            </g>
            <g mask="url(#mask-3)">
              <g transform="rotate(-8 302.374 -183.245)">
                <g>
                  <use fill="#000" filter="url(#filter-7)" xlinkHref="#path-6" />
                  <use fill="#545D79" xlinkHref="#path-6" />
                </g>
                <g fillRule="evenodd" strokeWidth="1" transform="translate(4.17 16.544)">
                  <path
                    fill="#FFF"
                    d="M3.333 0h15.334c1.159 0 1.58.12 2.003.347.424.227.756.56.983.983.226.424.347.844.347 2.003v12.334c0 1.159-.12 1.58-.347 2.003-.227.424-.56.756-.983.983-.424.226-.844.347-2.003.347H3.333c-1.159 0-1.58-.12-2.003-.347a2.362 2.362 0 01-.983-.983C.121 17.246 0 16.826 0 15.667V3.333c0-1.159.12-1.58.347-2.003.227-.424.56-.756.983-.983C1.754.121 2.174 0 3.333 0z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 -2.7586575e-13L8.38095238 -2.40005546e-13 8.38095238 5.27777778 7.33333333 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 13.7222222L8.38095238 13.7222222 8.38095238 19 7.33333333 19z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 0L14.6666667 0 14.6666667 5.27777778 13.6190476 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 13.7222222L14.6666667 13.7222222 14.6666667 19 13.6190476 19z"
                  />
                  <path
                    stroke="#2F52FB"
                    d="M15.31 5.778c.727 0 .998.058 1.266.201.23.123.41.303.532.532.143.268.202.539.202 1.267h0v3.444c0 .728-.059.999-.202 1.267-.122.23-.302.41-.532.532-.268.143-.539.201-1.266.201h0-8.62c-.727 0-.998-.058-1.266-.201a1.279 1.279 0 01-.532-.532c-.143-.268-.202-.539-.202-1.267h0V7.778c0-.728.059-.999.202-1.267.122-.23.302-.41.532-.532.268-.143.539-.201 1.266-.201h0z"
                  />
                </g>
              </g>
            </g>
            <g mask="url(#mask-3)">
              <g transform="rotate(-8 51.462 -294.199)">
                <g>
                  <use fill="#000" filter="url(#filter-9)" xlinkHref="#path-8" />
                  <use fill="#545D79" xlinkHref="#path-8" />
                </g>
                <g fillRule="evenodd" strokeWidth="1" transform="translate(4.17 16.544)">
                  <path
                    fill="#FFF"
                    d="M3.333 0h15.334c1.159 0 1.58.12 2.003.347.424.227.756.56.983.983.226.424.347.844.347 2.003v12.334c0 1.159-.12 1.58-.347 2.003-.227.424-.56.756-.983.983-.424.226-.844.347-2.003.347H3.333c-1.159 0-1.58-.12-2.003-.347a2.362 2.362 0 01-.983-.983C.121 17.246 0 16.826 0 15.667V3.333c0-1.159.12-1.58.347-2.003.227-.424.56-.756.983-.983C1.754.121 2.174 0 3.333 0z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 -2.7586575e-13L8.38095238 -2.40005546e-13 8.38095238 5.27777778 7.33333333 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 13.7222222L8.38095238 13.7222222 8.38095238 19 7.33333333 19z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 0L14.6666667 0 14.6666667 5.27777778 13.6190476 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 13.7222222L14.6666667 13.7222222 14.6666667 19 13.6190476 19z"
                  />
                  <path
                    stroke="#2F52FB"
                    d="M15.31 5.778c.727 0 .998.058 1.266.201.23.123.41.303.532.532.143.268.202.539.202 1.267h0v3.444c0 .728-.059.999-.202 1.267-.122.23-.302.41-.532.532-.268.143-.539.201-1.266.201h0-8.62c-.727 0-.998-.058-1.266-.201a1.279 1.279 0 01-.532-.532c-.143-.268-.202-.539-.202-1.267h0V7.778c0-.728.059-.999.202-1.267.122-.23.302-.41.532-.532.268-.143.539-.201 1.266-.201h0z"
                  />
                </g>
              </g>
            </g>
            <g mask="url(#mask-3)">
              <g transform="rotate(-8 614.188 -326.702)">
                <g>
                  <use fill="#000" filter="url(#filter-11)" xlinkHref="#path-10" />
                  <use fill="#545D79" xlinkHref="#path-10" />
                </g>
                <g fillRule="evenodd" strokeWidth="1" transform="translate(4.17 16.544)">
                  <path
                    fill="#FFF"
                    d="M3.333 0h15.334c1.159 0 1.58.12 2.003.347.424.227.756.56.983.983.226.424.347.844.347 2.003v12.334c0 1.159-.12 1.58-.347 2.003-.227.424-.56.756-.983.983-.424.226-.844.347-2.003.347H3.333c-1.159 0-1.58-.12-2.003-.347a2.362 2.362 0 01-.983-.983C.121 17.246 0 16.826 0 15.667V3.333c0-1.159.12-1.58.347-2.003.227-.424.56-.756.983-.983C1.754.121 2.174 0 3.333 0z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 -2.7586575e-13L8.38095238 -2.40005546e-13 8.38095238 5.27777778 7.33333333 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 13.7222222L8.38095238 13.7222222 8.38095238 19 7.33333333 19z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 0L14.6666667 0 14.6666667 5.27777778 13.6190476 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 13.7222222L14.6666667 13.7222222 14.6666667 19 13.6190476 19z"
                  />
                  <path
                    stroke="#2F52FB"
                    d="M15.31 5.778c.727 0 .998.058 1.266.201.23.123.41.303.532.532.143.268.202.539.202 1.267h0v3.444c0 .728-.059.999-.202 1.267-.122.23-.302.41-.532.532-.268.143-.539.201-1.266.201h0-8.62c-.727 0-.998-.058-1.266-.201a1.279 1.279 0 01-.532-.532c-.143-.268-.202-.539-.202-1.267h0V7.778c0-.728.059-.999.202-1.267.122-.23.302-.41.532-.532.268-.143.539-.201 1.266-.201h0z"
                  />
                </g>
              </g>
            </g>
            <g mask="url(#mask-3)">
              <g transform="rotate(-8 363.276 -437.657)">
                <g>
                  <use fill="#000" filter="url(#filter-14)" xlinkHref="#path-13" />
                  <use fill="url(#linearGradient-12)" xlinkHref="#path-13" />
                </g>
                <g fillRule="evenodd" strokeWidth="1" transform="translate(4.17 16.544)">
                  <path
                    fill="#FFF"
                    d="M3.333 0h15.334c1.159 0 1.58.12 2.003.347.424.227.756.56.983.983.226.424.347.844.347 2.003v12.334c0 1.159-.12 1.58-.347 2.003-.227.424-.56.756-.983.983-.424.226-.844.347-2.003.347H3.333c-1.159 0-1.58-.12-2.003-.347a2.362 2.362 0 01-.983-.983C.121 17.246 0 16.826 0 15.667V3.333c0-1.159.12-1.58.347-2.003.227-.424.56-.756.983-.983C1.754.121 2.174 0 3.333 0z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 -2.7586575e-13L8.38095238 -2.40005546e-13 8.38095238 5.27777778 7.33333333 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M7.33333333 13.7222222L8.38095238 13.7222222 8.38095238 19 7.33333333 19z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 0L14.6666667 0 14.6666667 5.27777778 13.6190476 5.27777778z"
                  />
                  <path
                    fill="#2F52FB"
                    d="M13.6190476 13.7222222L14.6666667 13.7222222 14.6666667 19 13.6190476 19z"
                  />
                  <path
                    stroke="#2F52FB"
                    d="M15.31 5.778c.727 0 .998.058 1.266.201.23.123.41.303.532.532.143.268.202.539.202 1.267h0v3.444c0 .728-.059.999-.202 1.267-.122.23-.302.41-.532.532-.268.143-.539.201-1.266.201h0-8.62c-.727 0-.998-.058-1.266-.201a1.279 1.279 0 01-.532-.532c-.143-.268-.202-.539-.202-1.267h0V7.778c0-.728.059-.999.202-1.267.122-.23.302-.41.532-.532.268-.143.539-.201 1.266-.201h0z"
                  />
                </g>
              </g>
            </g>
            <g mask="url(#mask-3)">
              <use fill="#000" filter="url(#filter-16)" xlinkHref="#path-15" />
              <use stroke="#FFF" strokeWidth="8" xlinkHref="#path-15" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SimsCircle;
